import ServiceBase from '../../ServiceBase';
import liquidityProxy from '../../../proxies/market/market-in-depth/LiquidityProxy';

class LiquidityService extends ServiceBase {
  getLiquiditySeries(params, source) {
    return this.applyMemoryCache('LiquidityService.getLiquiditySeries', params)(
      () => liquidityProxy.getLiquiditySeries(params, source),
    );
  }

  getBuSd(params) {
    return this.applyMemoryCache('LiquidityService.getBusd', params)(() =>
      liquidityProxy.getBuSd(params),
    );
  }
}

const liquidityService = new LiquidityService();
export default liquidityService;
